<template>
    <div class="pager-wrapper">
        <div class="pager">
            <a class="pager-btn-page pager-prev" :class="{'pager-disabled':prevDisable}" href="javascript:;" @click="jumpPrev()">{{$t('prev')}}</a>
            <template v-for="(i,idx) in pageSize">
                <span v-if="i==pageNo" class="pager-btn-page curr" :key="idx">{{i}}</span>
                <!--<a class="pager-btn-page" v-else-if="pageNo<5&&(i)<6" href="javascript:;" @click="jump(i)">-->
                <!--{{i}}-->
                <!--</a>-->
                <a class="pager-btn-page" :key="idx" v-else-if="pageSize<7||i==1||i==pageSize||(pageNo-1<=i&&i<=pageNo+1)" href="javascript:;" @click="jump(i)">
                    {{i}}
                </a>
                <!--<template v-else>-->
                <!--<span v-if="pageNo<5&&i==6" class="pager-spr">…</span>-->
                <!--<span v-if="pageNo==4&&i==7" class="pager-spr">…</span>-->
                <!--<span v-if="pageNo>4&&i==pageNo-3" class="pager-spr">…</span>-->
                <!--<span v-if="pageNo>4&&i==pageNo+3" class="pager-spr">…</span>-->
                <!--</template>-->
            </template>
            <a class="pager-btn-page pager-next" :class="{'pager-disabled':nextDisable}" href="javascript:;" @click="jumpNext()">{{$t('next')}}</a>
        </div>
        <div class="pager-limit mg-left15">
            {{$t('one_page')}} <Input class="pager-limit-input" number :maxlength="2" v-model="limit_curr" @on-enter="limitChange" /> {{$t('one_page_line')}}
        </div>
    </div>
</template>


<script>
    export default {
        name: "pager",
        model:{ //通过v-model传过来的参数
            prop: 'pageNo',
            event: 'jumpPage'
        },
        props:{
            limit:{
                type: Number,
                default: 10
            },
            pageSize:{
                type: Number,
                default: 1
            },
            pageNo:{ //通过v-model传过来的参数
                type: Number,
                default: 1
            }
        },
        data(){
            return {
                limit_curr: this.limit
            }
        },
        computed: {
            prevDisable: function(){ //“上一页”按钮是否可点
                if(this.pageNo > 1){
                    return false;
                }else{
                    return true
                }
            },
            nextDisable: function(){ //“下一页”按钮是否可点
                if(this.pageNo < this.pageSize && this.pageSize > 1){
                    return false;
                }else{
                    return true;
                }
            },
        },
        methods: {
            jumpPrev: function () { //点击上一页
                if (this.pageNo == 1) {
                    return;
                } else {
                    this.$emit('jumpPage', this.pageNo - 1);
                    this.$emit('onPagerChange', this.pageNo - 1);
                }
            },
            jumpNext: function () { //点击下一页
                if (this.pageNo == this.pageSize) {
                    return;
                } else {
                    this.$emit('jumpPage', this.pageNo + 1); //修改当前页码
                    this.$emit('onPagerChange', this.pageNo + 1); //跳转
                }
            },
            jump: function (id) { //直接跳转
                if (id > this.pageSize) {
                    id = this.pageSize;
                }
                this.$emit('jumpPage', id); //修改当前页码
                this.$emit('onPagerChange', id); //跳转
            },
            limitChange: function () {
                this.$emit('jumpPage', 1);
                this.$emit('onLimitChange', this.limit_curr);
            }
        }
    }
</script>

<style scoped>
    .pager-wrapper{
        display: flex;
        align-items: center;
    }
    .pager-limit{
        flex: 1;
    }
    .pager-limit .pager-limit-input{
        width: 30px;
    }
    .pager .pager-btn-page{
        border:solid 1px #e5e5e5;
        display: inline-block;
        width: 30px;
        height:30px;
        line-height:30px;
        text-align: center;
        margin: 0 5px;
        font-weight: bold;
        color: #333333;
        background-color: #fff;
    }
    .pager .pager-btn-page.curr{
        color: #fff;
        border:solid 1px #006eff;
        background-color: #006eff;
    }
    .pager  .pager-btn-page.pager-prev{
        width: auto;
        padding: 0 20px;
        margin-left: 0;
    }
    .pager  .pager-btn-page.pager-next{
        width: auto;
        padding: 0 20px;
        margin-right: 0;
    }
    .pager  .pager-btn-page.pager-next:not(.pager-disabled):active{
        background-color: #ececec;
    }
    .pager  .pager-btn-page.pager-disabled{
        background-color: #f4f4f4;
        color: #888;
    }
</style>


// WEBPACK FOOTER //
// src/components/myPager.vue